import { useState } from 'react';

import { EditOutlined } from '@mui/icons-material';
import { IconButton } from '@mui/material';

import { DreConfigConfiguracoesModal } from 'pages/financeiro/dre/configuracao/components/configuracoes/DreConfigConfiguracoesModal';
import { DreConfiguracao } from 'pages/financeiro/dre/configuracao/types';

export function DreConfigConfiguracoesEdit({ configuracao }: { configuracao: DreConfiguracao }) {
    const [openConfiguracoesModal, setOpenConfiguracoesModal] = useState(false);

    return (
        <>
            <DreConfigConfiguracoesModal configuracao={configuracao} open={openConfiguracoesModal} setOpen={setOpenConfiguracoesModal} />

            <IconButton sx={{ width: 20, height: 20, color: configuracao.color.text }} onClick={() => setOpenConfiguracoesModal(true)}>
                <EditOutlined fontSize="small" />
            </IconButton>
        </>
    );
}
